import { reference } from '../../api/reference';
import { Role } from '../../interfaces/types';

async function fetchRoles(): Promise<Role[]> {
	try {
		return await reference.getRoles();
	} catch (error) {
		throw error;
	}
}

export const referenceService = {
	fetchRoles,
};
